import { PUBLIC } from '@/api/constants'
import * as types from '@/constants/store-mutation-types'
import { serialize } from '@/lib/util'
import config from 'SrcConfig'
import axios from 'axios'
import Qs from 'qs'

export default class ApiCore {
  constructor(store, path, baseUrl = null, headers = null) {
    this._path = path || ''
    this._baseUrl = baseUrl || config.apiServerUrl
    this._store = store
    this._headers = headers
  }

  _urlencode(str) {
    if (str && str.length) {
      return encodeURIComponent(str)
    } else {
      return str
    }
  }

  _setUploadProgress(progress) {
    this._store.commit(types.SET_UPLOAD_PROGRESS, progress)
  }
  _setDownloadProgress(progress) {
    this._store.commit(types.SET_DOWNLOAD_PROGRESS, progress)
  }

  _setOfflineFlag(value) {
    this._store.commit(types.SET_OFFLINE, value)
  }

  _logout() {
    this._store.commit(types.LOGOUT)
  }

  _refresh() {
    return this._sendRequest({
      _refreshHeader: true,
      path: `${PUBLIC}/account`,
      action: 'refresh',
      method: 'GET'
    })
      .then((res) => {
        this._store.commit(types.SET_REFRESHED_TOKEN, res)
        return res.accessToken
      })
      .catch((err) => {
        console.log(err)
        if (err.includes('عبارت امنیتی منقضی شده است')) {
          this._logout()
        }
      })
  }
  // accessToken
  // path
  // action
  // method
  // params
  // body
  // form
  // onUploadProgress
  // onDownloadProgress
  // showProgress
  // ! DEPRECATED
  fingerprint = (function (window, screen, navigator) {
    function checksum(str) {
      var hash = 5381,
        i = str.length

      while (i--) hash = (hash * 33) ^ str.charCodeAt(i)

      return hash >>> 0
    }

    function map(arr, fn) {
      var i = 0,
        len = arr.length,
        ret = []
      while (i < len) {
        ret[i] = fn(arr[i++])
      }
      return ret
    }

    return checksum(
      [
        navigator.userAgent,
        [screen.height, screen.width, screen.colorDepth].join('x'),
        new Date().getTimezoneOffset(),
        !!window.sessionStorage,
        !!window.$cookies,
        map(navigator.plugins, function (plugin) {
          return [
            plugin.name,
            plugin.description,
            map(plugin, function (mime) {
              return [mime.type, mime.suffixes].join('~')
            }).join(',')
          ].join('::')
        }).join(';')
      ].join('###')
    )
  })(this, screen, navigator)

  _generateHeaders(refresh = false) {
    const headers = {
      CSN: this._store.getters.fingerprint,
      CVS: this._store.getters.appVersion,
      CTY: this._store.getters.clientType
    }

    const account = this._store.getters.account

    if (account)
      headers.Authorization = `Bearer ${
        refresh ? account.refreshToken : account.accessToken
      }`

    return { ...headers }
  }

  _sendRequest(o) {
    const req = {
      url: `${this._baseUrl}${o.path.length ? '/' : ''}${o.path}${
        o.action ? '/' : ''
      }${o.action || ''}`,
      method: o.method,
      params: o.params,
      headers:
        this._headers || this._generateHeaders(o._refreshHeader || false),
      responseType: o.responseType || 'json',
      paramsSerializer: (params) =>
        Qs.stringify(params, { arrayFormat: 'repeat' }),
      onUploadProgress: (e) => {
        if (o.showProgress) {
          const progress = parseInt((e.loaded * 100) / e.total)
          this._setUploadProgress(progress)
        }
        if (o.onUploadProgress) o.onUploadProgress(e)
      },
      onDownloadProgress: (e) => {
        if (o.showProgress) {
          const progress = parseInt((e.loaded * 100) / e.total)
          this._setDownloadProgress(progress)
        }
        if (o.onDownloadProgress) o.onDownloadProgress(e)
      }
    }

    if (o.body) req.data = o.body
    else if (o.form) {
      if (o.form instanceof FormData) {
        req.data = o.form
      } else {
        Object.keys(o.form).forEach((key) => {
          if (!o.form[key] && o.form[key] !== 0) delete o.form[key]
        })
        req.data = serialize(o.form)
      }
    }

    return axios(req)
      .then((res) => {
        if (o.showProgress) {
          this._setUploadProgress(0)
          this._setDownloadProgress(0)
        }
        return res.data
      })
      .catch((err) => {
        if (o.showProgress) {
          this._setUploadProgress(0)
          this._setDownloadProgress(0)
        }
        if (err.message === 'Network Error') {
          this._setOfflineFlag(true)
        }
        if (err.response) {
          if (err.response.status === 401) {
            this._logout()
            if (location.pathname !== config.homeUrl)
              location.assign(
                `/login?redirect=${location.pathname + location.search}`
              )
            else location.assign('/login')
          }

          if (err.response.status === 403 || err.response.status === 405)
            location.assign('/access-denied')

          if (err.response.status === 406) {
            // this._logout()
            if (err.response.data.error.includes('TOKEN_ACCESS_EXPIRED')) {
              return this._refresh()
                .then((newToken) => {
                  o.accessToken = newToken
                  return this._sendRequest(o)
                })
                .catch(() => {
                  this._logout()
                })
            }
          }
          // if (err.response.status === 406) {
          //   return this._refresh().then(newToken => {
          //     o.accessToken = newToken
          //     return this._sendRequest(o)
          //   })
          // }
          throw (
            err.response.data.errorCode + ' : ' + err.response.data.description
          )
        } else {
          throw err
        }
      })
  }

  // action
  // method
  // params
  // body
  // form
  // onUploadProgress
  // onDownloadProgress
  // showProgress
  _request(o) {
    o.path = this._path

    return this._sendRequest(o)
  }
}
